import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const InsertRowBelow = (props) => (
  <SvgIcon
    width="20.174"
    height="16.137"
    viewBox="0 0 20.174 16.137"
    {...props}
  >
    <g transform="translate(0.03)">
      <path
        d="M151.14,226.988v-5.7c.009-.05.016-.1.026-.151a1.993,1.993,0,0,1,1.431-1.622,3.62,3.62,0,0,1,.4-.083h13.771c.112.021.225.037.335.064a2.025,2.025,0,0,1,1.522,1.973q0,1.479,0,2.957a.109.109,0,0,0,.054.1,5.811,5.811,0,0,1,.818.673,6.06,6.06,0,0,1,1.354,2,5.858,5.858,0,0,1,.425,1.643c.014.135.027.271.04.406v.551a.671.671,0,0,0-.013.078,5.391,5.391,0,0,1-.149,1.021,5.979,5.979,0,0,1-2.53,3.645,5.88,5.88,0,0,1-3.008,1.013,6.054,6.054,0,0,1-6.387-5.58,3.524,3.524,0,0,1,.009-.8c.016-.107.027-.215.041-.328h-6.071c-.083,0-.166,0-.248-.012a2.019,2.019,0,0,1-1.734-1.443C151.186,227.257,151.167,227.121,151.14,226.988Zm16.136-3.171c0-.008,0-.021,0-.034,0-.784,0-1.569,0-2.353a.662.662,0,0,0-.671-.654H153.159a.664.664,0,0,0-.673.673v5.379a.665.665,0,0,0,.675.673h6.347a.084.084,0,0,0,.1-.065,6.041,6.041,0,0,1,1.809-2.566,5.915,5.915,0,0,1,3.316-1.38,5.429,5.429,0,0,1,1.722.108C166.725,223.66,167,223.742,167.276,223.817Zm-2.013.992a4.7,4.7,0,1,0,3.356,1.4A4.7,4.7,0,0,0,165.263,224.809Z"
        transform="translate(-151.17 -219.43)"
      />
      <path
        d="M151.11,905.22h6.7l-3.364,3.365a.238.238,0,0,0-.035-.061q-1.621-1.622-3.243-3.243a.621.621,0,0,0-.061-.048Z"
        transform="translate(-151.14 -894.462)"
      />
      <path
        d="M843.964,652.391h-2.683v2.683h-1.346v-2.683H837.25v-1.346h2.683V648.36h1.346v2.682h2.685Z"
        transform="translate(-826.516 -641.631)"
      />
    </g>
  </SvgIcon>
);
export default InsertRowBelow;



// WEBPACK FOOTER //
// ./src/common/icons/InsertRowBelow/index.tsx